import {
  Box,
  Dialog,
  IconButton,
  Rating,
  Stack,
  Typography,
} from "@mui/material";
import AvatarGenerator from "../../profilePic/GenerateAvatar";
import CloseIcon from "@mui/icons-material/Close";
import { LOCALSTORAGE_KEY } from "../../../utils/Constants";
import { getTempleName } from "../../../utils/HelperFunctions";
import "./TestimonialCard.scss";
import ImageView from "../../ImageView/ImageView";

export default function TestimonialModal({
  open,
  onClose,
  reviewData,
  pujaDetails,
  selectedTempleDetails,
}: any) {
  const userName = reviewData?.userName?.split(" ");
  const savedLanguage =
    localStorage.getItem(LOCALSTORAGE_KEY.LANG_CODE) ?? "en";
  const templeName = getTempleName(selectedTempleDetails, savedLanguage);
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "22px",
        },
      }}
    >
      <Box className="testiCard custom">
        <IconButton onClick={onClose} className="closeBtn">
          <CloseIcon />
        </IconButton>
        <Box className="cardImg">
          <ImageView
            src={
              reviewData?.categoryImage
                ? reviewData?.categoryImage
                : pujaDetails?.pujaBg?.uri
                ? pujaDetails?.pujaBg?.uri
                : "https://tinyurl.com/tdogrl"
            }
            alt="Puja Image"
          ></ImageView>

          {/* Overlay Text */}
          {/* <Box className="overflowedText">
            <Typography>{reviewData?.templeName || templeName}</Typography>
            <Typography>
              {reviewData?.pujaName || pujaDetails?.pujaName}
            </Typography>
          </Box> */}
        </Box>
        <Box padding={2}>
          <Box className="cardTop">
            <Stack direction="row" alignItems="flex-start" spacing={2}>
              <Box className="imageSec">
                {reviewData?.userImage ? (
                  <ImageView src={reviewData?.userImage} alt="Devotee" />
                ) : (
                  <AvatarGenerator
                    firstName={userName[0]}
                    lastName={userName[userName.length - 1]}
                  />
                )}
              </Box>
              <Box className="nameSec">
                <Typography className="boldText">
                  {reviewData?.userName ?? ""}
                </Typography>
                <Typography className="profText">
                  {reviewData?.userProfession ?? ""}
                </Typography>
                <Typography className="placeText">
                  {reviewData?.userPlace ?? ""}
                </Typography>
                <Rating
                  name="simple-controlled"
                  readOnly
                  value={reviewData?.rating ?? 3}
                  className="ratingStar"
                />
              </Box>
            </Stack>
          </Box>

          <Box className="cardBottom">
            <Box className="feedbackWrapper">
              <Typography className="feedbackFullText">
                {reviewData?.feedBack}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
}
